import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import waitlistPublicApi from '@/features/public/waitlist/api/waitlistPublicApi.ts';
import { waitlistPublicApiQueryKeys } from '@/features/public/waitlist/api/waitlistPublicApi.queryKeys.ts';
import { BookingTourBasicDataDto } from '@/features/public/booking/types/BookingTourBasicDataDto.ts';

const useGetWaitlistBasicInfo = (orgSlug: string, tourSlug: string) => {
  return useQuery(getWaitlistBasicInfoQueryOptions(orgSlug, tourSlug));
};

export const getWaitlistBasicInfoQueryOptions = (
  orgSlug: string,
  tourSlug: string,
): UseQueryOptions<BookingTourBasicDataDto> => ({
  queryKey: waitlistPublicApiQueryKeys.basicInfo(orgSlug, tourSlug),
  queryFn: () => waitlistPublicApi.getBasicTourInfo(orgSlug, tourSlug),
  staleTime: 1000 * 60,
  gcTime: 1000 * 60 * 5,
});

export default useGetWaitlistBasicInfo;
